import { Component, Input, OnInit } from '@angular/core';
import { DocumentModel } from 'src/app/models/document.model';
import { DocumentActor } from 'src/app/models/actors';
import { formatDate } from '@angular/common';
import { Is_Adopt_Action, Is_Sign_Action } from 'src/app/constants/actor-action.enum';
import { ViewerDataService } from '../viewer-data.service';

/**
 * A component that recieves and displays completed Actors/Actions for the Given document
 */
@Component({
  selector: 'app-document-actor-summary',
  templateUrl: './document-actor-summary.component.html'
})
export class DocumentActorSummaryComponent implements OnInit {

  @Input() document!: DocumentModel;

  /** 
   * Displayed in the Summary as already completed Actors
   */
  finishedDocumentActors: DocumentActor[] = [];
  /**
   * Used to display Who signed INCASE of XBRL and when
   */
  finishedXbrlSigner: DocumentActor | undefined;
  constructor(private viewerDataService: ViewerDataService) {
  }

  /**
   * DISPLAY the normal action completed line
   */
  shouldDisplayRegularAction(actor: DocumentActor): boolean {
    return !Is_Adopt_Action(actor.action) || (Is_Adopt_Action(actor.action) && actor.adoptionChoice == true);
  }
  /**
   * DISPLAY the normal action completed line
   */
  shouldDisplayAdoptNoAction(actor: DocumentActor): boolean {
    return !this.shouldDisplayRegularAction(actor) && (Is_Adopt_Action(actor.action) && actor.adoptionChoice == false);
  }
  ngOnInit() {
    this.viewerDataService.getActors$().subscribe(actors => {
      if (!actors || actors.length <= 0) {
        this.finishedDocumentActors = [];
        this.finishedXbrlSigner = undefined;
        return;
      }
      let forThisDocumentActors = actors.filter(x => x.documentId == this.document.id);
      // first remove sign actions, as signatures are on the document
      this.finishedDocumentActors = forThisDocumentActors.filter(a => !Is_Sign_Action(a.action) && a.hasSigned);
      // PDF sign actions are displayed in the document, not below it, filter THOSE out:
      let documentIsPDf = this.document.documentType == 'RegularPdf';
      this.finishedXbrlSigner = undefined;
      if (!documentIsPDf) {
        this.finishedXbrlSigner = forThisDocumentActors.find(a => Is_Sign_Action(a.action) && a.hasSigned);
      }
    });
  }
  GenerateActionId(actor: DocumentActor) {
    return actor.action + '_' + actor.id;

  }

  /**
   * Presents the data for the frontend while being bound to code and the shared things
   * @param date
   * @returns 
   */
  public getFormattedDate(date: Date | null) {
    if (!date) return '';
    return formatDate(date, 'dd-MM-y HH:mm:ss', 'en-US');
  }


}
